



























































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import Select from '@/components/Select.vue'
import {
  EPccUploadTaskStatus,
  EUserPermissions,
  IFacility,
  IFacilityCredentials,
  IGetUploadFacilityDataTaskFilters,
  IPccUploadFile,
  IPccUploadTask,
  ESortOrder,
  Dictionary,
  Primitive
} from '@zunta/configurations'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import FacilityCredentialsModal from '@/views/app/admin/components/FacilityCredentialsModal.vue'
import Card from '@/components/Card.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import Table from '@/components/tables/Table.vue'
import { ITableColumn, ITableConfig } from '@/interfaces'
import Avatar from '@/components/Avatar.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { UserModule } from '@/store/modules/user.module'
import Switcher from '@/components/Switcher.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { completedRequestColumns, groupedTaskList, isReportUploaded, openRequestColumns } from './helpers/uploads'
import Icon from '@/components/Icon.vue'
import './styles/uploads.scss'
import { makeErrorNotification } from '@/utils/notification'
import { PCCUploadTaskStatusMap } from '@/constants'
import { Debounce } from 'vue-debounce-decorator'
const moment = require('moment')
const countdown = require('moment-countdown')

@Component({
  components: {
    Table,
    Card,
    ResidentLabel,
    Select,
    SearchInput,
    Avatar,
    Switcher,
    Icon,
    DateTimeLabel,
    FacilityCredentialsModal,
  }

})
export default class Uploads extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EUserPermissions = EUserPermissions
  completedToggle: boolean = false
  user: User = Api.getUser() as User
  filters: IGetUploadFacilityDataTaskFilters = {
    skip: 0,
    limit: 20,
    isOpen: this.$route.query.isOpen === 'true' || this.$route.query.isClosed !== 'true' ? true : undefined,
    isClosed: this.$route.query.isClosed === 'true' ? true : undefined,
  }
  isReportUploaded = isReportUploaded
  groupedTaskList = groupedTaskList
  tooltipText: string = 'Click to Copy'
  reloadTableKey: number = 1
  isLoading: boolean = false
  itemReports: any = {}
  showFacilityCredentialsModal = false

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'right: -1.5rem;',
      class: 'rounded-bottom'
    },
    maxHeight: 'calc(100vh - 388px)',
    minHeight: '100px',
    useQuery: true,
    usePagination: true,
    fetchFunction: this.facilityModuleInstance.getUploadFacilityTasks,
    columns: []
  }

  get filteredConfig () {
    const config = { ...this.config }
    if (this.filters.isOpen) {
      const actions = [...completedRequestColumns].pop()
      config.columns = [
        ...completedRequestColumns.filter(column => column.key && !['actions', 'updatedAt', 'isMPI'].includes(column.key)),
        ...openRequestColumns,
        actions as ITableColumn
      ]
    } else {
      config.columns = completedRequestColumns
    }
    return config
  }

  get taskList () {
    const taskList = this.$store.state.facility.uploadFacilityTasks as IPccUploadTask[]
    return this.filters.isClosed ? taskList : groupedTaskList(taskList)
  }

  get total () {
    return this.$store.state.facility.totalUploadFacilityTasks
  }

  get query () {
    const routeQuery = (this.$route.query || {}) as Dictionary<Primitive>
    if (routeQuery.limit) { routeQuery.limit = parseInt(routeQuery.limit as string, 10) }
    if (routeQuery.skip) { routeQuery.skip = parseInt(routeQuery.skip as string, 10) }
    return routeQuery
  }

  get userList () {
    return this.$store.state.user.users
  }

  getUser (id: number) {
    return this.userList.find((user: any) => user.id === id)
  }

  copyText (text: string) {
    navigator.clipboard.writeText(text)
    this.tooltipText = 'Copied to Clipboard'

    setTimeout(() => {
      this.tooltipText = 'Click to Copy'
    }, 500)
  }

  changeFileName (file: File, name: string) {
    const blob = file.slice(0, file.size, file.type)
    return new File([blob], name, { type: file.type })
  }

  selectFile (reportName: string, itemId: number) {
    const file = (this.$refs[`${reportName}-${itemId}`] as any).files[0]
    const newFile = this.changeFileName(file, reportName)
    if (!this.itemReports.hasOwnProperty(itemId)) {
      this.itemReports[itemId] = {}
    }
    this.itemReports[itemId][reportName] = newFile
    this.reloadTable()
  }

  excludeFile (itemId: number, type: string) {
    this.itemReports[itemId][type] = null
    this.reloadTable()
  }

  handleResult (result: any) {
    if (result.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `Upload reports error`,
        message: result.message,
        icon: 'warning'
      })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        header: `Reports successfully uploaded`,
        message: '',
        icon: 'check'
      })
    }
  }

  async uploadReports (id: number, facilityId: number) {
    this.isLoading = true
    const formData = new FormData()
    if (this.itemReports[id]) {
      Object.values(this.itemReports[id]).map((file: any) => {
        formData.append(file.name, file)
      })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'Upload files',
        message: 'You should upload files to submit',
        icon: 'warning'
      })
      return
    }
    const res = await Api.facility.uploadReports(facilityId, formData)
    this.handleResult(res)
    this.isLoading = false
  }

  async assignUserToTaskGroup (task: IPccUploadTask) {
    const facilityCredentials = ((task.facility as IFacility).facilityCredentials || {}) as IFacilityCredentials
    const usernameOrTaskId = this.filters.isClosed
      ? { taskId: task.id }
      : { username: facilityCredentials.username }
    await Api.facility.assignUserToTaskGroup(usernameOrTaskId)
  }

  async downloadPccUploadFile (pccUploadTask: IPccUploadTask) {
    const pccUploadFiles = pccUploadTask.pccUploadFiles
    if (pccUploadFiles && pccUploadFiles.length) {
      const facility = (pccUploadTask.facility as IFacility)
      const fileName = facility.pccMatchFacilityName || facility.name || `Reports_${pccUploadTask.id}`
      const fileIds = pccUploadFiles.map(file => file.id) as number[]
      const { message, hasCorruptFiles } = await Api.facility.downloadPccUploadFile(fileIds, fileName)
      if (hasCorruptFiles) {
        makeErrorNotification(this, message)
      }
    }
  }

  async mounted () {
    this.$socketManager.subscribeToPccRequestUpdates()
    await this.userModuleInstance.getAdminUsersList({})
  }

  async created () {
    this.$eventBus.$on('notifyPccRequestUpdate', () => this.reloadTable())
  }

  getTimestampLabel (date: Date | string) {
    const timeline = moment(date).countdown(countdown.DAYS, NaN, 1).toString()
    return timeline ? `${timeline} ago` : 'Just Now'
  }

  toggleCompletedTasks (close: boolean) {
    const filter = close ? { isClosed: true, sortOrder: ESortOrder.DESC } : { isOpen: true, sortOrder: ESortOrder.ASC }
    this.filters = { limit: 20, skip: 0, ...filter }
  }

  getStatusLabel (status: EPccUploadTaskStatus) {
    return PCCUploadTaskStatusMap[status] || 'N/A'
  }

  getReportTooltipText (item: IPccUploadTask, type: 'resident' | 'contact' | 'transaction') {
    const uploadedResult = isReportUploaded(item, type, true)
    if (uploadedResult === 'not-uploaded') {
      return 'Not Uploaded'
    }
    if (!uploadedResult) {
      return 'Complete'
    }
    return uploadedResult.charAt(0).toUpperCase() + uploadedResult.slice(1)
  }

  @Debounce(2000)
  reloadTable () {
    this.reloadTableKey++
  }

  getFacilityCreds (pccUploadTask: IPccUploadTask) {
    return ((pccUploadTask.facility as IFacility).facilityCredentials || {}) as IFacilityCredentials
  }

  @Debounce(300)
  async getOTPCode (facility: Partial<IFacility>) {
    const facilityCredentials = facility.facilityCredentials as IFacilityCredentials
    if (!facilityCredentials || !facilityCredentials.mfaSecret || !facilityCredentials.username) {
      return
    }
    this.tooltipText = 'Request in progress'
    const response = await this.facilityModuleInstance.getOTPCodeForUsername(facilityCredentials.username)
    if (response.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `OTP Error`,
        message: response.message,
        icon: 'warning'
      })
    } else {
      navigator.clipboard.writeText(String(response))
      this.tooltipText = 'Copied to Clipboard'
      setTimeout(() => {
        this.tooltipText = 'Click to Copy'
      }, 500)
    }
  }
}
